import ScrollActivityService from 'ember-user-activity/services/scroll-activity';

export default class ScrollActivity extends ScrollActivityService {}
